import * as Yup from 'yup';


export const contactsValidation = Yup.object().shape({
    client: Yup.string().required('lient Tags/Categories is required'),
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),

 });